import styled from "styled-components";

export const StyledProgressBar = styled.div`
  display: flex;
  flex-direction: column;
  height: 9.3rem;
  justify-content: space-around;
  margin: 0 auto;
  margin: 1.7em 0;
  width: 100%;
`;

export const Title = styled.h2`
  font-weight: 300;
  margin-left: 1rem;
  text-align: left;
`;

export const ContainerInfoCredit = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0px 1rem 0 1rem;
`;
